export const translations = {
  es: {
    nav: {
      services: "Servicios",
      about: "Sobre nosotros",
      brands: "Marcas",
      reviews: "Opiniones",
      contact: "Contacto",
      bookCta: "Reserva cita gratuita",
    },
    hero: {
      badge: "Centro audiológico en El Campello",
      title1: "Recupera el placer",
      title2: "de escuchar",
      subtitle:
        "Revisiones auditivas y audiometrías gratuitas. 30 días de prueba de audífonos sin compromiso. Atención cercana y personalizada.",
      ctaPrimary: "Solicita tu revisión gratuita",
      ctaSecondary: "Llámanos: 965 637 618",
      bulletsTitle: "Por qué elegirnos",
      bullets: [
        "Audiometrías y revisiones 100% gratuitas",
        "30 días de prueba sin compromiso",
        "Atendido por Violeta Jacobo, audióloga",
        "Trabajamos con las mejores marcas",
      ],
    },
    notice:
      "Del 17 al 21 de agosto permanecemos cerrados por vacaciones. ¡Volvemos el lunes 24 de agosto!",
    promo: {
      title: "30 días de prueba gratis",
      text: "Pruébate tus audífonos durante 30 días en tu casa, en el trabajo y con tus seres queridos. Sin compromiso de compra y con seguimiento personalizado.",
      cta: "Quiero probarlos gratis",
      invisibleBadge: "Audífonos invisibles",
    },
    services: {
      kicker: "Nuestros servicios",
      title: "Cuidamos de tu audición de principio a fin",
      subtitle:
        "Servicios completos de audiología en El Campello, desde el diagnóstico hasta la adaptación y el mantenimiento.",
      items: [
        {
          title: "Servicio a domicilio",
          desc: "¿No puedes desplazarte? Vamos a tu casa para revisiones, ajustes y entregas de audífonos. Atención personalizada sin moverte del sofá.",
        },
        {
          title: "Audiometrías gratuitas",
          desc: "Revisiones auditivas completas sin coste para conocer el estado real de tu audición.",
        },
        {
          title: "Diagnóstico de pérdida auditiva",
          desc: "Detección de hipoacusia, presbiacusia y problemas asociados con tecnología avanzada.",
        },
        {
          title: "Adaptación de audífonos",
          desc: "Selección, programación y ajuste personalizado de tu audífono para máximo confort.",
        },
        {
          title: "Reparación y mantenimiento",
          desc: "Servicio técnico, limpieza, recambios y mantenimiento de todas las marcas.",
        },
        {
          title: "Tinnitus / Acúfenos",
          desc: "Tratamiento y asesoramiento especializado para zumbidos y acúfenos.",
        },
        {
          title: "Protección auditiva",
          desc: "Tapones a medida para natación, descanso, música, motorismo y entornos laborales.",
        },
        {
          title: "Seguimiento audiológico",
          desc: "Acompañamiento continuo y seguro frente a robo, pérdida o rotura.",
        },
      ],
    },
    accessories: {
      kicker: "Más productos",
      title: "Accesorios auditivos",
      subtitle:
        "Disponemos de una amplia gama de accesorios y ayudas auditivas para mejorar tu comodidad y calidad de vida.",
      categories: [
        {
          title: "Protectores auditivos",
          items: [
            "Tapones para baño y natación.",
            "Tapones antirruido.",
            "Tapones para dormir.",
            "Modelos estándar y personalizados a medida.",
          ],
        },
        {
          title: "Ayudas para la audición y comunicación",
          items: [
            "Sistemas de escucha para televisión Siemens.",
            "Teléfonos adaptados para personas con pérdida auditiva.",
            "Dispositivos de ayuda para la comunicación diaria.",
          ],
        },
        {
          title: "Mantenimiento de audífonos",
          items: [
            "Deshumidificadores para alargar la vida útil de los audífonos.",
            "Pastillas deshumidificadoras.",
            "Productos de limpieza y mantenimiento.",
          ],
        },
        {
          title: "Pilas y baterías",
          items: [
            "Amplio stock de pilas para audífonos.",
            "Pilas al mejor precio del mercado.",
          ],
        },
      ],
      footer:
        "Visítanos y te asesoraremos para encontrar la solución más adecuada a tus necesidades.",
    },
    benefits: {
      kicker: "Ventajas exclusivas",
      title: "Compra con total tranquilidad",
      items: [
        {
          title: "5 años de garantía",
          desc: "Todos nuestros audífonos incluyen 5 años de garantía. Tranquilidad total a largo plazo.",
          highlight: "5 AÑOS",
        },
        {
          title: "Financiación 0%",
          desc: "Paga tus audífonos cómodamente con financiación 0% interés y 0% comisiones.",
          highlight: "0%",
        },
      ],
    },
    education: {
      kicker: "Información útil",
      title: "Trastornos auditivos que tratamos",
      items: [
        {
          title: "Hipoacusia",
          desc: "Pérdida auditiva de leve a profunda que puede afectar a una o ambas orejas. Detectarla pronto cambia tu calidad de vida.",
        },
        {
          title: "Presbiacusia",
          desc: "Pérdida auditiva asociada a la edad. Es progresiva y muy frecuente a partir de los 60 años.",
        },
        {
          title: "Tinnitus / Acúfenos",
          desc: "Zumbidos o pitidos en el oído sin fuente externa. Disponemos de programas específicos para reducir su impacto.",
        },
      ],
    },
    brands: {
      kicker: "Marcas",
      title: "Trabajamos con los líderes del sector",
      subtitle:
        "Audífonos de última generación de los fabricantes más reconocidos.",
    },
    about: {
      kicker: "Sobre nosotros",
      title: "Violeta Jacobo, tu audióloga de confianza",
      p1: "En Amplisoon Centro Audiológico llevamos años cuidando de la audición de los vecinos de El Campello y alrededores. Nuestra responsable, Violeta Jacobo, ofrece una atención cercana, profesional y personalizada para cada paciente.",
      p2: "Somos Punto CEP (Centro Especialista Phonak), un reconocimiento que avala nuestra formación, tecnología y experiencia para ofrecerte las mejores soluciones auditivas. Además, contamos con un programa específico de audiología infantil para acompañar a los más pequeños y a sus familias.",
      p3: "Creemos en explicarlo todo con claridad, sin prisas y sin compromiso. Por eso ofrecemos revisiones gratuitas y 30 días de prueba con tu audífono, para que decidas con total tranquilidad.",
      cepBadge: "Punto CEP · Centro Especialista Phonak",
      philipsBadge: "Centro Autorizado Philips",
      kidsBadge: "Audiología infantil",
      galleryTitle: "Así es nuestro centro de El Campello",
      gallerySubtitle: "Instalaciones modernas y acogedoras, pensadas para que te sientas como en casa.",
      galleryCaptions: [
        "Sala de espera",
        "Sala de espera",
        "Recepción",
        "Gabinete de audiología",
        "Gabinete infantil",
        "Gabinete infantil",
      ],
      stats: [
        { value: "+20", label: "Años de experiencia" },
        { value: "CEP", label: "Centro Especialista Phonak" },
        { value: "7", label: "Marcas premium" },
      ],
    },
    reviews: {
      kicker: "Opiniones reales",
      title: "Lo que dicen nuestros pacientes",
      subtitle:
        "Testimonios recogidos de pacientes del centro de El Campello.",
    },
    contact: {
      kicker: "Contacto",
      title: "Pide tu cita gratuita",
      subtitle:
        "Reserva tu revisión auditiva sin coste. Te contactaremos en menos de 24 h laborables.",
      labels: {
        name: "Nombre y apellidos",
        phone: "Teléfono",
        email: "Email (opcional)",
        service: "¿Qué servicio te interesa?",
        date: "Fecha preferida (opcional)",
        message: "Cuéntanos brevemente",
      },
      placeholders: {
        name: "Ej. María García",
        phone: "Ej. 600 12 34 56",
        email: "tucorreo@ejemplo.com",
        service: "Selecciona un servicio",
        message: "¿En qué podemos ayudarte?",
      },
      submit: "Solicitar cita",
      submitting: "Enviando...",
      success: "¡Gracias! Hemos recibido tu solicitud. Te llamaremos pronto.",
      error: "Ha ocurrido un error. Inténtalo de nuevo o llámanos directamente.",
      info: {
        address: "Avenida de la Generalitat, 50D, 03560 El Campello, Alicante",
        addressReference: "Enfrente del Druni y al lado de Bodegas Baeza",
        address2: "Avenida Illice, 57, 03320 Torrellano (Elche)",
        address2Reference: "Enfrente de Ferretería Sempere",
        address2Label: "Segundo centro",
        phones: "965 637 618 · +34 722 797 599",
        phonesCampello: "965 637 618 · +34 722 797 599",
        phonesTorrellano: "965 682 209 · +34 644 258 557",
        email: "audifonosamplisoon@gmail.com",
        hours: "Horario",
        hoursCampelloLabel: "El Campello",
        hoursTorrellanoLabel: "Torrellano (Elche)",
        hoursCampello: [
          "Lunes a Viernes (mañanas): 09:30 – 14:00",
          "Martes y Jueves (tardes): 17:30 – 20:00",
          "Sábados y Domingos: Cerrado",
        ],
        hoursTorrellano: [
          "Lunes a Viernes: 10:00 – 14:00 y 17:30 – 20:00",
          "Sábados: 10:00 – 14:00",
          "Domingos: Cerrado",
        ],
        hoursLines: [
          "Lunes a Jueves: 09:30 – 14:00 y 17:30 – 20:00",
          "Viernes: 09:30 – 14:00",
          "Sábados y Domingos: Cerrado",
        ],
      },
    },
    footer: {
      tagline:
        "Centro audiológico especializado en El Campello. Revisiones gratuitas y 30 días de prueba sin compromiso.",
      rights: "Todos los derechos reservados.",
      privacy: "Aviso legal y privacidad",
    },
    kids: {
      kicker: "Audiología infantil",
      title: "Cuidamos la audición de tu hijo para que no se pierda ningún sonido de su infancia",
      subtitle:
        "Especialistas en audición infantil: conectamos a los más pequeños con el mundo, con pruebas lúdicas y un acompañamiento cercano para toda la familia.",
      signsTitle: "¿Cuándo acudir? Señales de alarma",
      signsIntro:
        "Muchos padres llegan dudando si el comportamiento de su hijo es normal. Estas son algunas señales que conviene revisar:",
      signs: [
        {
          age: "Niños pequeños",
          items: [
            "Tarda en empezar a hablar.",
            "Dice mucho '¿qué?' o pide que le repitan las cosas.",
            "Parece que solo atiende cuando se le mira de frente.",
          ],
        },
        {
          age: "Edad escolar",
          items: [
            "Sube demasiado el volumen de la televisión o la tablet.",
            "Bajo rendimiento escolar repentino sin causa aparente.",
            "Se distrae con facilidad en entornos ruidosos.",
          ],
        },
      ],
      servicesTitle: "Nuestros servicios para los más pequeños",
      services: [
        {
          title: "Estudios auditivos pediátricos",
          desc: "Pruebas de audición lúdicas mediante juegos y tecnología no invasiva que no causa ninguna molestia.",
        },
        {
          title: "Adaptación de audífonos infantiles",
          desc: "Modelos cómodos, resistentes, coloridos y con conectividad para el colegio y el día a día.",
        },
        {
          title: "Revisiones y seguimiento",
          desc: "Acompañamiento constante durante su crecimiento y el desarrollo del lenguaje.",
        },
      ],
      cta: "Pide una revisión infantil gratuita",
      aidTitle: "Audífonos gratuitos de 0 a 26 años",
      aidIntro:
        "Existe una ayuda pública que permite a niños y jóvenes de hasta 26 años acceder a audífonos sin coste.",
      aidItems: [
        "Ayuda pública para niños y jóvenes de hasta 26 años.",
        "Acceso a audífonos gratuitos.",
        "Asesoramiento personalizado durante toda la tramitación.",
        "Centro habilitado para recepcionar las recetas oficiales y gestionar la adaptación.",
      ],
      aidNote: "Consulta con nuestro equipo y descubre si puedes beneficiarte de esta ayuda.",
      aidCta: "Consulta si puedes beneficiarte",
    },
    common: {
      bookNow: "Reserva cita",
      callUs: "Llamar ahora",
      whatsapp: "WhatsApp",
      free: "Gratis",
    },
  },
  en: {
    nav: {
      services: "Services",
      about: "About us",
      brands: "Brands",
      reviews: "Reviews",
      contact: "Contact",
      bookCta: "Book free appointment",
    },
    hero: {
      badge: "Audiology centre in El Campello",
      title1: "Rediscover the joy",
      title2: "of hearing",
      subtitle:
        "Free hearing tests and audiometries. 30-day no-commitment hearing aid trial. Friendly, personalised care.",
      ctaPrimary: "Book your free hearing test",
      ctaSecondary: "Call us: 965 637 618",
      bulletsTitle: "Why choose us",
      bullets: [
        "100% free audiometries and check-ups",
        "30-day free trial, no commitment",
        "Cared for by Violeta Jacobo, audiologist",
        "We work with the best brands",
      ],
    },
    notice:
      "We are closed from 17 to 21 August for holidays. We're back on Monday 24 August!",
    promo: {
      title: "30-day free trial",
      text: "Try your hearing aids for 30 days at home, at work and with your loved ones. No purchase commitment and personalised follow-up.",
      cta: "I want to try them free",
      invisibleBadge: "Invisible hearing aids",
    },
    services: {
      kicker: "Our services",
      title: "We care for your hearing from start to finish",
      subtitle:
        "Complete audiology services in El Campello, from diagnosis to fitting and maintenance.",
      items: [
        {
          title: "Home service",
          desc: "Can't come to the centre? We come to your home for check-ups, adjustments and deliveries. Personalised care without leaving your sofa.",
        },
        {
          title: "Free audiometries",
          desc: "Complete hearing tests at no cost to truly understand your hearing.",
        },
        {
          title: "Hearing loss diagnosis",
          desc: "Detection of hypoacusis, presbycusis and related issues using advanced technology.",
        },
        {
          title: "Hearing aid fitting",
          desc: "Selection, programming and personalised adjustment for maximum comfort.",
        },
        {
          title: "Repair & maintenance",
          desc: "Technical service, cleaning, spare parts and maintenance for all brands.",
        },
        {
          title: "Tinnitus care",
          desc: "Specialised treatment and counselling for buzzing and tinnitus.",
        },
        {
          title: "Hearing protection",
          desc: "Custom ear plugs for swimming, sleep, music, motorcycling and work.",
        },
        {
          title: "Audiology follow-up",
          desc: "Ongoing care plus insurance against theft, loss or breakage.",
        },
      ],
    },
    accessories: {
      kicker: "More products",
      title: "Hearing accessories",
      subtitle:
        "We carry a wide range of accessories and hearing aids to improve your comfort and quality of life.",
      categories: [
        {
          title: "Hearing protectors",
          items: [
            "Plugs for bathing and swimming.",
            "Anti-noise plugs.",
            "Plugs for sleeping.",
            "Standard and custom-made models.",
          ],
        },
        {
          title: "Hearing and communication aids",
          items: [
            "Siemens TV listening systems.",
            "Phones adapted for hearing loss.",
            "Daily communication aid devices.",
          ],
        },
        {
          title: "Hearing aid maintenance",
          items: [
            "Dehumidifiers to extend hearing aid lifespan.",
            "Dehumidifier tablets.",
            "Cleaning and maintenance products.",
          ],
        },
        {
          title: "Batteries",
          items: [
            "Wide stock of hearing aid batteries.",
            "Best market prices.",
          ],
        },
      ],
      footer: "Visit us and we'll help you find the best solution for your needs.",
    },
    benefits: {
      kicker: "Exclusive benefits",
      title: "Buy with complete peace of mind",
      items: [
        {
          title: "5-year warranty",
          desc: "All our hearing aids include a 5-year warranty. Long-term peace of mind.",
          highlight: "5 YEARS",
        },
        {
          title: "0% financing",
          desc: "Pay for your hearing aids comfortably with 0% interest and 0% commission financing.",
          highlight: "0%",
        },
      ],
    },
    education: {
      kicker: "Useful information",
      title: "Hearing conditions we treat",
      items: [
        {
          title: "Hypoacusis",
          desc: "Hearing loss from mild to profound, in one or both ears. Detecting it early changes your quality of life.",
        },
        {
          title: "Presbycusis",
          desc: "Age-related hearing loss. Progressive and very common from the age of 60.",
        },
        {
          title: "Tinnitus",
          desc: "Buzzing or ringing in the ear with no external source. We offer specific programs to reduce its impact.",
        },
      ],
    },
    brands: {
      kicker: "Brands",
      title: "We work with the industry leaders",
      subtitle: "Latest-generation hearing aids from the most renowned manufacturers.",
    },
    about: {
      kicker: "About us",
      title: "Violeta Jacobo, your trusted audiologist",
      p1: "At Amplisoon Audiology Centre we have been caring for the hearing of El Campello's neighbours for years. Our manager, Violeta Jacobo, provides close, professional and personalised care for every patient.",
      p2: "We are a CEP Point (Phonak Specialist Centre), a recognition that endorses our training, technology and experience to offer you the best hearing solutions. We also run a specific paediatric audiology programme to support the little ones and their families.",
      p3: "We believe in explaining everything clearly, without rushing and with no commitment. That's why we offer free check-ups and a 30-day trial with your hearing aid, so you can decide with complete peace of mind.",
      cepBadge: "CEP Point · Phonak Specialist Centre",
      philipsBadge: "Philips Authorised Centre",
      kidsBadge: "Paediatric audiology",
      galleryTitle: "Take a look at our El Campello centre",
      gallerySubtitle: "Modern, welcoming facilities designed to make you feel at home.",
      galleryCaptions: [
        "Waiting room",
        "Waiting room",
        "Reception",
        "Audiology room",
        "Kids' audiology room",
        "Kids' audiology room",
      ],
      stats: [
        { value: "+20", label: "Years of experience" },
        { value: "CEP", label: "Phonak Specialist Centre" },
        { value: "7", label: "Premium brands" },
      ],
    },
    reviews: {
      kicker: "Real reviews",
      title: "What our patients say",
      subtitle: "Testimonials collected from patients at the El Campello centre.",
    },
    contact: {
      kicker: "Contact",
      title: "Book your free appointment",
      subtitle:
        "Reserve your free hearing test. We'll reach out within 24 working hours.",
      labels: {
        name: "Full name",
        phone: "Phone",
        email: "Email (optional)",
        service: "Which service are you interested in?",
        date: "Preferred date (optional)",
        message: "Tell us briefly",
      },
      placeholders: {
        name: "E.g. Mary Smith",
        phone: "E.g. 600 12 34 56",
        email: "your@email.com",
        service: "Select a service",
        message: "How can we help you?",
      },
      submit: "Request appointment",
      submitting: "Sending...",
      success: "Thank you! We've received your request. We'll call you soon.",
      error: "Something went wrong. Try again or call us directly.",
      info: {
        address: "Avenida de la Generalitat, 50D, 03560 El Campello, Alicante",
        addressReference: "Across from Druni and next to Bodegas Baeza",
        address2: "Avenida Illice, 57, 03320 Torrellano (Elche)",
        address2Reference: "Across from Ferretería Sempere",
        address2Label: "Second centre",
        phones: "965 637 618 · +34 722 797 599",
        phonesCampello: "965 637 618 · +34 722 797 599",
        phonesTorrellano: "965 682 209 · +34 644 258 557",
        email: "audifonosamplisoon@gmail.com",
        hours: "Opening hours",
        hoursCampelloLabel: "El Campello",
        hoursTorrellanoLabel: "Torrellano (Elche)",
        hoursCampello: [
          "Monday to Friday (mornings): 09:30 – 14:00",
          "Tuesday & Thursday (afternoons): 17:30 – 20:00",
          "Saturday & Sunday: Closed",
        ],
        hoursTorrellano: [
          "Monday to Friday: 10:00 – 14:00 and 17:30 – 20:00",
          "Saturday: 10:00 – 14:00",
          "Sunday: Closed",
        ],
        hoursLines: [
          "Monday to Thursday: 09:30 – 14:00 and 17:30 – 20:00",
          "Friday: 09:30 – 14:00",
          "Saturday & Sunday: Closed",
        ],
      },
    },
    footer: {
      tagline:
        "Specialised audiology centre in El Campello. Free check-ups and 30-day no-commitment trial.",
      rights: "All rights reserved.",
      privacy: "Legal notice and privacy",
    },
    kids: {
      kicker: "Paediatric audiology",
      title: "We care for your child's hearing so they never miss a single sound of their childhood",
      subtitle:
        "Specialists in paediatric hearing: we connect the little ones with the world, with playful tests and close support for the whole family.",
      signsTitle: "When to come in? Warning signs",
      signsIntro:
        "Many parents arrive unsure whether their child's behaviour is normal. These are some signs worth checking:",
      signs: [
        {
          age: "Young children",
          items: [
            "Slow to start speaking.",
            "Often says 'what?' or asks to repeat.",
            "Only seems to listen when looking directly at you.",
          ],
        },
        {
          age: "School age",
          items: [
            "Turns the TV or tablet volume too high.",
            "Sudden drop in school performance with no clear cause.",
            "Easily distracted in noisy environments.",
          ],
        },
      ],
      servicesTitle: "Our services for the youngest",
      services: [
        {
          title: "Paediatric hearing tests",
          desc: "Playful hearing tests through games and non-invasive technology that causes no discomfort.",
        },
        {
          title: "Children's hearing aid fitting",
          desc: "Comfortable, sturdy, colourful models with connectivity for school and everyday life.",
        },
        {
          title: "Check-ups and follow-up",
          desc: "Ongoing support during their growth and language development.",
        },
      ],
      aidTitle: "Free hearing aids from 0 to 26 years",
      aidIntro:
        "A public aid programme allows children and young people up to 26 years old to access hearing aids at no cost.",
      aidItems: [
        "Public aid for children and young people up to 26 years old.",
        "Access to free hearing aids.",
        "Personalised guidance during the whole process.",
        "Our centre is authorised to receive official prescriptions and manage the fitting.",
      ],
      aidNote: "Ask our team and find out if you can benefit from this aid.",
      aidCta: "Check if you qualify",
      cta: "Book a free paediatric check-up",
    },
    common: {
      bookNow: "Book now",
      callUs: "Call now",
      whatsapp: "WhatsApp",
      free: "Free",
    },
  },
  va: {
    nav: {
      services: "Serveis",
      about: "Sobre nosaltres",
      brands: "Marques",
      reviews: "Opinions",
      contact: "Contacte",
      bookCta: "Reserva cita gratuïta",
    },
    hero: {
      badge: "Centre audiològic a El Campello",
      title1: "Recupera el plaer",
      title2: "d'escoltar",
      subtitle:
        "Revisions auditives i audiometries gratuïtes. 30 dies de prova d'audiòfons sense compromís. Atenció pròxima i personalitzada.",
      ctaPrimary: "Demana la teua revisió gratuïta",
      ctaSecondary: "Telefona'ns: 965 637 618",
      bulletsTitle: "Per què triar-nos",
      bullets: [
        "Audiometries i revisions 100% gratuïtes",
        "30 dies de prova sense compromís",
        "Atés per Violeta Jacobo, audiòloga",
        "Treballem amb les millors marques",
      ],
    },
    notice:
      "Del 17 al 21 d'agost romanem tancats per vacances. Tornem el dilluns 24 d'agost!",
    promo: {
      title: "30 dies de prova gratis",
      text: "Prova els teus audiòfons durant 30 dies a casa, al treball i amb els teus éssers estimats. Sense compromís de compra i amb seguiment personalitzat.",
      cta: "Vull provar-los gratis",
      invisibleBadge: "Audiòfons invisibles",
    },
    services: {
      kicker: "Els nostres serveis",
      title: "Cuidem la teua audició de principi a fi",
      subtitle:
        "Serveis complets d'audiologia a El Campello, des del diagnòstic fins a l'adaptació i el manteniment.",
      items: [
        { title: "Servei a domicili", desc: "No pots desplaçar-te? Anem a sa teua casa per a revisions, ajustaments i lliuraments d'audiòfons. Atenció personalitzada sense moure't del sofà." },
        { title: "Audiometries gratuïtes", desc: "Revisions auditives completes sense cost per a conéixer l'estat real de la teua audició." },
        { title: "Diagnòstic de pèrdua auditiva", desc: "Detecció d'hipoacúsia, presbiacúsia i problemes associats amb tecnologia avançada." },
        { title: "Adaptació d'audiòfons", desc: "Selecció, programació i ajustament personalitzat del teu audiòfon per a màxim confort." },
        { title: "Reparació i manteniment", desc: "Servei tècnic, neteja, recanvis i manteniment de totes les marques." },
        { title: "Tinnitus / Acúfens", desc: "Tractament i assessorament especialitzat per a brunzits i acúfens." },
        { title: "Protecció auditiva", desc: "Taps a mesura per a natació, descans, música, motorisme i entorns laborals." },
        { title: "Seguiment audiològic", desc: "Acompanyament continu i assegurança contra roba­tori, pèrdua o trencament." },
      ],
    },
    benefits: {
      kicker: "Avantatges exclusius",
      title: "Compra amb total tranquil·litat",
      items: [
        { title: "5 anys de garantia", desc: "Tots els nostres audiòfons inclouen 5 anys de garantia. Tranquil·litat total a llarg termini.", highlight: "5 ANYS" },
        { title: "Finançament 0%", desc: "Paga els teus audiòfons còmodament amb finançament 0% interés i 0% comissions.", highlight: "0%" },
      ],
    },
    accessories: {
      kicker: "Més productes",
      title: "Accessoris auditius",
      subtitle: "Disposem d'una àmplia gamma d'accessoris i ajudes auditives per a millorar la teua comoditat i qualitat de vida.",
      categories: [
        { title: "Protectors auditius", items: ["Taps per a bany i natació.", "Taps antisoroll.", "Taps per a dormir.", "Models estàndard i personalitzats a mesura."] },
        { title: "Ajudes per a l'audició i comunicació", items: ["Sistemes d'escolta per a televisió Siemens.", "Telèfons adaptats per a persones amb pèrdua auditiva.", "Dispositius d'ajuda per a la comunicació diària."] },
        { title: "Manteniment d'audiòfons", items: ["Deshumidificadors per a allargar la vida útil dels audiòfons.", "Pastilles deshumidificadores.", "Productes de neteja i manteniment."] },
        { title: "Piles i bateries", items: ["Ampli estoc de piles per a audiòfons.", "Piles al millor preu del mercat."] },
      ],
      footer: "Visita'ns i t'assessorarem per a trobar la millor solució a les teues necessitats.",
    },
    kids: {
      kicker: "Audiologia infantil",
      title: "Cuidem l'audició del teu fill perquè no es perda cap so de la seua infància",
      subtitle: "Especialistes en audició infantil: connectem els més menuts amb el món, amb proves lúdiques i acompanyament pròxim per a tota la família.",
      signsTitle: "Quan acudir? Senyals d'alarma",
      signsIntro: "Molts pares arriben dubtant si el comportament del seu fill és normal. Estes són algunes senyals que convé revisar:",
      signs: [
        { age: "Xiquets menuts", items: ["Tarda a començar a parlar.", "Diu sovint 'què?' o demana que li repetisquen les coses.", "Sembla que només atén quan se li mira de front."] },
        { age: "Edat escolar", items: ["Puja massa el volum de la televisió o la tableta.", "Baix rendiment escolar sobtat sense causa aparent.", "Es distrau amb facilitat en entorns sorollosos."] },
      ],
      servicesTitle: "Els nostres serveis per als més menuts",
      services: [
        { title: "Estudis auditius pediàtrics", desc: "Proves d'audició lúdiques amb jocs i tecnologia no invasiva que no causa cap molèstia." },
        { title: "Adaptació d'audiòfons infantils", desc: "Models còmodes, resistents, acolorits i amb connectivitat per a l'escola i el dia a dia." },
        { title: "Revisions i seguiment", desc: "Acompanyament constant durant el seu creixement i el desenvolupament del llenguatge." },
      ],
      cta: "Demana una revisió infantil gratuïta",
      aidTitle: "Audiòfons gratuïts de 0 a 26 anys",
      aidIntro: "Hi ha una ajuda pública que permet a xiquets i jóvens fins als 26 anys accedir a audiòfons sense cost.",
      aidItems: [
        "Ajuda pública per a xiquets i jóvens fins als 26 anys.",
        "Accés a audiòfons gratuïts.",
        "Assessorament personalitzat durant tota la tramitació.",
        "Centre habilitat per a recepcionar les receptes oficials i gestionar l'adaptació.",
      ],
      aidNote: "Consulta amb el nostre equip i descobreix si pots beneficiar-te d'esta ajuda.",
      aidCta: "Consulta si pots beneficiar-te",
    },
    education: {
      kicker: "Informació útil",
      title: "Trastorns auditius que tractem",
      items: [
        { title: "Hipoacúsia", desc: "Pèrdua auditiva de lleu a profunda que pot afectar una o dos orelles. Detectar-la prompte canvia la teua qualitat de vida." },
        { title: "Presbiacúsia", desc: "Pèrdua auditiva associada a l'edat. És progressiva i molt freqüent a partir dels 60 anys." },
        { title: "Tinnitus / Acúfens", desc: "Brunzits o xiulits en l'oïda sense font externa. Disposem de programes específics per a reduir el seu impacte." },
      ],
    },
    brands: {
      kicker: "Marques",
      title: "Treballem amb els líders del sector",
      subtitle: "Audiòfons d'última generació dels fabricants més reconeguts.",
    },
    about: {
      kicker: "Sobre nosaltres",
      title: "Violeta Jacobo, la teua audiòloga de confiança",
      p1: "A Amplisoon Centre Audiològic fa anys que cuidem l'audició dels veïns d'El Campello i voltants. La nostra responsable, Violeta Jacobo, oferix una atenció pròxima, professional i personalitzada per a cada pacient.",
      p2: "Som Punt CEP (Centre Especialista Phonak), un reconeixement que avala la nostra formació, tecnologia i experiència per a oferir-te les millors solucions auditives. A més, disposem d'un programa específic d'audiologia infantil per a acompanyar els més menuts i les seues famílies.",
      p3: "Creem en explicar-ho tot amb claredat, sense presses i sense compromís. Per això oferim revisions gratuïtes i 30 dies de prova amb el teu audiòfon, perquè decidisques amb tota tranquil·litat.",
      cepBadge: "Punt CEP · Centre Especialista Phonak",
      philipsBadge: "Centre Autoritzat Philips",
      kidsBadge: "Audiologia infantil",
      galleryTitle: "Així és el nostre centre d'El Campello",
      gallerySubtitle: "Instal·lacions modernes i acollidores, pensades perquè et sentes com a casa.",
      galleryCaptions: [
        "Sala d'espera",
        "Sala d'espera",
        "Recepció",
        "Gabinet d'audiologia",
        "Gabinet infantil",
        "Gabinet infantil",
      ],
      stats: [
        { value: "+20", label: "Anys d'experiència" },
        { value: "CEP", label: "Centre Especialista Phonak" },
        { value: "7", label: "Marques premium" },
      ],
    },
    reviews: {
      kicker: "Opinions reals",
      title: "El que diuen els nostres pacients",
      subtitle: "Testimonis recollits de pacients del centre d'El Campello.",
    },
    contact: {
      kicker: "Contacte",
      title: "Demana la teua cita gratuïta",
      subtitle: "Reserva la teua revisió auditiva sense cost. Et contactarem en menys de 24 h laborables.",
      labels: {
        name: "Nom i cognoms",
        phone: "Telèfon",
        email: "Email (opcional)",
        service: "Quin servei t'interessa?",
        date: "Data preferida (opcional)",
        message: "Conta'ns breument",
      },
      placeholders: {
        name: "P. ex. Maria Garcia",
        phone: "P. ex. 600 12 34 56",
        email: "elteucorreu@exemple.com",
        service: "Selecciona un servei",
        message: "En què podem ajudar-te?",
      },
      submit: "Sol·licitar cita",
      submitting: "Enviant...",
      success: "Gràcies! Hem rebut la teua sol·licitud. Et telefonarem prompte.",
      error: "Ha ocorregut un error. Torna-ho a provar o telefona'ns directament.",
      info: {
        address: "Avinguda de la Generalitat, 50D, 03560 El Campello, Alacant",
        addressReference: "Enfront de Druni i al costat de Bodegues Baeza",
        address2: "Avinguda Illice, 57, 03320 Torrellano (Elx)",
        address2Reference: "Enfront de Ferreteria Sempere",
        address2Label: "Segon centre",
        phones: "965 637 618 · +34 722 797 599",
        phonesCampello: "965 637 618 · +34 722 797 599",
        phonesTorrellano: "965 682 209 · +34 644 258 557",
        email: "audifonosamplisoon@gmail.com",
        hours: "Horari",
        hoursCampelloLabel: "El Campello",
        hoursTorrellanoLabel: "Torrellano (Elx)",
        hoursCampello: [
          "Dilluns a Divendres (matins): 09:30 – 14:00",
          "Dimarts i Dijous (vesprades): 17:30 – 20:00",
          "Dissabtes i Diumenges: Tancat",
        ],
        hoursTorrellano: [
          "Dilluns a Divendres: 10:00 – 14:00 i 17:30 – 20:00",
          "Dissabtes: 10:00 – 14:00",
          "Diumenges: Tancat",
        ],
        hoursLines: [
          "Dilluns a Dijous: 09:30 – 14:00 i 17:30 – 20:00",
          "Divendres: 09:30 – 14:00",
          "Dissabtes i Diumenges: Tancat",
        ],
      },
    },
    footer: {
      tagline: "Centre audiològic especialitzat a El Campello. Revisions gratuïtes i 30 dies de prova sense compromís.",
      rights: "Tots els drets reservats.",
      privacy: "Avís legal i privacitat",
    },
    common: {
      bookNow: "Reserva cita",
      callUs: "Telefonar ara",
      whatsapp: "WhatsApp",
      free: "Gratis",
    },
  },
};

export const reviewsData = [
  {
    name: "María Sánchez",
    role: "El Campello",
    rating: 5,
    text:
      "Trato excepcional de Violeta. Me hizo la audiometría sin coste y me explicó todo con muchísima paciencia. Probé los audífonos 30 días y ahora oigo a mis nietos como antes.",
    text_en:
      "Exceptional care from Violeta. She did the audiometry for free and explained everything with so much patience. After the 30-day trial I can hear my grandchildren like before.",
  },
  {
    name: "Antonio Pérez",
    role: "Alicante",
    rating: 5,
    text:
      "Profesionales de verdad. Llevaba años con acúfenos y por fin he encontrado un centro que se ha tomado mi caso en serio. Muy recomendable.",
    text_en:
      "True professionals. I had been dealing with tinnitus for years and finally found a centre that took my case seriously. Highly recommended.",
  },
  {
    name: "Carmen Llorca",
    role: "El Campello",
    rating: 5,
    text:
      "Compré los audífonos para mi padre. Le hicieron las pruebas gratis y le adaptaron unos Phonak perfectos. El seguimiento posterior ha sido impecable.",
    text_en:
      "I bought hearing aids for my dad. They tested him for free and fitted perfect Phonak devices. The follow-up has been impeccable.",
  },
  {
    name: "José Ramírez",
    role: "Villajoyosa",
    rating: 5,
    text:
      "Lo mejor de Amplisoon es la cercanía. Te tratan como si fueras de la familia. Los tapones a medida para el agua me han cambiado los baños en verano.",
    text_en:
      "The best thing about Amplisoon is the warmth. They treat you like family. Custom ear plugs for water have changed my summer swims.",
  },
  {
    name: "Pilar Navarro",
    role: "Mutxamel",
    rating: 5,
    text:
      "Hace un año me adaptaron unos Oticon y la diferencia es brutal. Buen precio, buenas marcas y, sobre todo, una atención que no encuentras en otros sitios.",
    text_en:
      "A year ago they fitted me with Oticon devices and the difference is huge. Good price, great brands and, above all, care you won't find elsewhere.",
  },
  {
    name: "Francisco Gómez",
    role: "El Campello",
    rating: 5,
    text:
      "Reparé mis audífonos antiguos en el día. Servicio rápido, honesto y a un precio justo. Totalmente recomendable.",
    text_en:
      "They repaired my old hearing aids the same day. Fast, honest service at a fair price. Totally recommended.",
  },
];

export const brandList = [
  { name: "Phonak", logo: "https://customer-assets.emergentagent.com/job_audicion-amplisoon/artifacts/yil3ofme_phonak.png" },
  { name: "Oticon", logo: "https://customer-assets.emergentagent.com/job_audicion-amplisoon/artifacts/77ikt0mv_oticon%20%281%29.png" },
  { name: "Bernafon", logo: "https://customer-assets.emergentagent.com/job_audicion-amplisoon/artifacts/hii4fa3j_bernafon%20%281%29.png" },
  { name: "Audibel", logo: "https://customer-assets.emergentagent.com/job_audicion-amplisoon/artifacts/9m4uwifc_audibel%20%281%29.png" },
  { name: "Starkey", logo: "https://customer-assets.emergentagent.com/job_audicion-amplisoon/artifacts/ya1hk2zx_starkey%20%281%29.png" },
  { name: "Philips", logo: "https://customer-assets.emergentagent.com/job_audicion-amplisoon/artifacts/ayonynv5_philips%20%281%29.png" },
  { name: "Interton GN", logo: "https://customer-assets.emergentagent.com/job_audicion-amplisoon/artifacts/ri07dno9_interton%20%281%29.png" },
  { name: "WSA", logo: "https://customer-assets.emergentagent.com/job_audicion-amplisoon/artifacts/swr7o9v3_wsa.png" },
  { name: "Signia", logo: "https://customer-assets.emergentagent.com/job_audicion-amplisoon/artifacts/8bxbtv3i_signia.png" },
];

export const secondaryBrands = [];
